<template>
  <div>
    <span class="title" v-if="businessNames.length">
      商家验证
    </span>
    <div class="name-content-scroll">
      <template  v-if="businessNames.length">
        <div class="business-check" v-for="item in businessNames" :key="item">
          <span :title="'您的手机号已经是' + item + '的联系人。'">您的手机号已经是{{ item }}的联系人。</span>
          <el-button plain type="single-number" @click="openShopClick(item)">立即开店</el-button>
        </div>
      </template>
    </div>
    <span class="title">
      注册商家
    </span>
    <el-form :model="form" ref="form" :rules="rules" @submit.native.prevent>
      <el-form-item prop="companyName">
<!--        @input="inputCompany"-->
        <el-input v-model.trim="form.companyName"  maxlength="36" placeholder="请填写商家名称（即公司全称）"></el-input>
      </el-form-item>
    </el-form>
    <div class="data-bottom-btn" @click="nextStepClick">
      立即注册
    </div>
  </div>
</template>

<script>
import { getSaveContact } from '@/api/register-shop'
import { getQryBusinessByName } from '@/api/new-company'
import { qrySupInfoListItem, checkSupplierBlackList, checkBusinessInfo } from "@/api/apply-shop-edit.js";

export default {
  name: "new-company",
  props: {
    businessNames: Array,
    registerInfo: Object
  },
  data () {
    return {
      form: {
        companyName: '',
      },
      rules: {
        companyName: [
          { required: true, message: '请填写公司全称', trigger: 'blur' },
          { pattern: /^[\u4e00-\u9fa5\(\)\（\）]/, message: '请输入中文或括号', trigger: 'blur' }
        ]
      },
      downFileUrl: this.$addUrlPerFix('sra.iccec.cn/apis/sra/store/users/signup/downloadTemplateNote')
    }
  },
  mounted () {
    console.log(this.registerInfo, '信息')
  },
  methods: {
    // inputCompany () {
    //   this.form.companyName = this.form.companyName.replace(
    //     /[^\u4e00-\u9fa5\(\)\（\）]/g,
    //     ""
    //   );
    // },
    openShopClick (businessName) {
      console.log(this.registerInfo, 'registerInfo')
      let params = {
        contactName: this.registerInfo.contactName,
        phone: this.registerInfo.phone,
        businessName: businessName,
        isShowLoading: true,
        loadingMessage: '注册中,请稍等...'
      }
      getQryBusinessByName(params).then(res => {
        console.log(res, '校驗商家名稱')
        if (res.data.code === '0') {
          if (res.data.data.isExist === 'true') {
            let type = 'error'
            let message = `抱歉，${businessName}已经创建过店铺，不能重复开店。`
            this.$message({
              type,
              message,
              offset: document.body.clientHeight / 2 - 21
            })
          } else if (res.data.data.isExist === 'false') {
            sessionStorage.removeItem('contactId')
            sessionStorage.removeItem('businessName')
            sessionStorage.setItem('contactId', res.data.data.contactId)
            sessionStorage.setItem('businessName', businessName)
            this.$router.replace('/business-open-shop/apply-shop-info')
            this.$store.dispatch("businessOpenShopSetStep", 3)
          }
        }else {
          this.$message({
            type: 'error',
            message: res.data.message,
            ccuiCustom: true,
            showClose: true
          })
        }
      })
    },
    nextStepClick () {
      let submitParams = this.registerInfo
      submitParams.businessName = this.form.companyName
      submitParams.supName = this.form.companyName
      submitParams.isShowLoading = true
      this.$refs['form'].validate(async (valid) => {
        if (!valid) return
        try {
          // 入网申请检测
          const res = await qrySupInfoListItem({...submitParams, customCapture: true})
          const { code, data = [] } = res.data
          const flag = (code === '0' && (!data.length || data[0].emVendorInfoBO && !data[0].emVendorInfoBO.purVendorCode)) || (code !== '0' && code === '1')
          if (flag) {
            const h = this.$createElement;
            const message = h('div', null, [
              h('p', null, [
                h('span', null, '当前企业：'),
                h('strong', { style: 'color: #FF142F' }, this.form.companyName),
                h('span', null, '未在中交集团供应链平台入网，请先完成入网申请。')
              ]),
              h('p', { style: 'font-size: 12px; padding-top: 10px' }, [
                h('span', { style: 'color: #999; padding-right: 2px' }, '点击下载'),
                h('span', {
                  style: 'color: #409EFF; cursor: pointer',
                  on: {
                    click: () => {
                      this.download()
                    }
                  },
                }, '供应商准入条件及资质文件填报要求')
              ]),
            ])
            this.$confirm.confirm(message, '入网提示', {
              distinguishCancelAndClose: true,
              dangerouslyUseHTMLString: true,
              confirmButtonText: '入网申请 >>',
              cancelButtonText: '取消',
              customClass: 'custom-message-box'
            }).then(() => {
              let routeUrl = this.$router.resolve({
                path: '/maReady01',
              });
              window.open(routeUrl.href, "_blank");
            })
            return
          } else if (code !== '0' && code !== '1') {
            // 接口报错，自行处理一下
            this.$message({
              type: 'error',
              message: res.data.message,
              ccuiCustom: true,
              showClose: true
            })
            return
          } else {
            sessionStorage.removeItem('emVendorInfo')
            const [{ emVendorInfoBO }] = res.data.data
            // 检测店铺是否已注册过
            const orderPurchaseType = sessionStorage.getItem('orderPurchaseType')
            const params = {
              compName: this.form.companyName,
              shopType: orderPurchaseType === '0' ? 10 : 11,
            }
            const res0 = await checkBusinessInfo(params)
            if (res0.data.code !== '0') {
              this.$message({
                type: 'error',
                message: res.data.message,
                ccuiCustom: true,
                showClose: true
              })
              return
            }
            // 继续检测黑名单
            const res1 = await checkSupplierBlackList({ supCode: emVendorInfoBO.purVendorCode })
            if (res1.data.code !== '0') {
              this.$message({
                type: 'error',
                message: res.data.message,
                ccuiCustom: true,
                showClose: true
              })
              return
            }
            sessionStorage.setItem('emVendorInfo', JSON.stringify(emVendorInfoBO))
          }
          getSaveContact(submitParams).then(res => {
            if (res.data.code === '0') {
              if (res.data.data.exist) {
                this.$message({
                  type: 'error',
                  message: res.data.message,
                  ccuiCustom: true,
                  showClose: true
                })
                return false
              }
              sessionStorage.removeItem('contactId')
              sessionStorage.removeItem('businessName')
              sessionStorage.setItem('businessName', submitParams.businessName)
              sessionStorage.setItem('contactId', res.data.data.contactId)
              this.$router.replace('/business-open-shop/apply-shop-info')
              this.$store.dispatch("businessOpenShopSetStep", 3)
            }else {
              this.$message({
                type: 'error',
                message: res.data.message,
                ccuiCustom: true,
                showClose: true
              })
            }
          })
        } catch (error) {
          console.log("🚀 ~ this.$refs['form'].validate ~ error:", error)
        }
      })
    },
    download() {
      console.log("🚀 ~ download ~ this.downFileUrl:", this.downFileUrl)
      window.open(this.downFileUrl, "_blank");
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  font-size: 20px;
  color: #4A4A4A;
  line-height: 28px;
  display: block;
  font-weight: 600;
  margin-bottom: 20px;
  font-family: PingFangSC-Semibold, PingFangSC
}
/deep/ .el-form-item {
  margin-bottom: 20px;
}
/deep/ .el-input {
  width: 500px;
  input {
    height: 40px;
    border-radius: 4px;
  }
}
.name-content-scroll {
  max-height: 100px;
  overflow-y: auto;
  padding-right: 20px;
}
.business-check {
  font-size: 13px;
  color: #4A4A4A;
  line-height: 17px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }
}
/deep/ .el-button {
  background: #FFFFFF;
  border-color: #FF142F;
  span {
    color: #FF142F;
  }
  &:hover, &:active {
    border-color: #FF142F !important;
    background-color: #ffedef !important;
  }
  &:focus {
    border-color: #FF142F !important;
  }
}
.data-bottom-btn{
  width: 500px;
  height: 40px;
  background: rgba(255, 20, 47, 1);
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFangSC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  cursor: pointer;
  font-weight: 600;
}
</style>
<style lang="scss">
.el-message-box.custom-message-box {
  width: 750px !important;
  .el-message-box__title {
    text-align: center;
  }
  .el-message-box__content {
    padding: 20px 45px;
  }
  .el-message-box__btns {
    text-align: center;
  }
}
</style>
